import { COMMON_STATUS, FOOD_STATUS } from '../constants';
import store from '../store'
import { ensureArray } from './helper';
import { roundMoney } from './index';

export const validAmount = amount => roundMoney(amount);

export const getTotalOrdered = ordered => ordered.reduce(
    (sum, f) => {
        const { additionFoods, amount, price } = f
        const totalAdd = ensureArray(additionFoods).reduce(
            (sum, cur) => validAmount(sum + cur.price),
            0
        )
        const total = validAmount((price + totalAdd) * amount);
        return {
            totalOrdered: validAmount(sum.totalOrdered + total),
            originTotalOrdered: validAmount(sum.originTotalOrdered + total),
        }
    },
    {
        totalOrdered: 0,
        originTotalOrdered: 0,
    }
);

export const getCurrentDistanceData = currentDistance => {
    const { deliver_setting } = store.getState().RestaurantReducer.settings
    if (!deliver_setting) {
        return {
            min_money: 0,
            km: 0
        };
    }

    const { distance } = deliver_setting;
    let currentDistanceData = null;

    ensureArray(distance).map(el => {
        const { km } = el

        if (currentDistance <= km && (!currentDistanceData || km < currentDistanceData.km)) {
            currentDistanceData = el;
        }
    });

    return currentDistanceData;
}

export const isFoodSoldOut = food => {
    if (!food) {
        return false;
    }

    if (food?.status === FOOD_STATUS.SOLD_OUT) {
        return true;
    }

    const foodDetailsSoldOut = foodDetails => ensureArray(foodDetails?.beilageItems)
        .some(beilage => {
            if (!beilage.option) {
                return false;
            }
            let hasBeilageAvailable = false;
            for (let bei of ensureArray(beilage.food_datas)) {
                if (bei.status !== COMMON_STATUS.ACTIVE) {
                    if (bei.required) {
                        return true;
                    }
                } else {
                    hasBeilageAvailable = true;
                }
            }
            return !hasBeilageAvailable;
        });

    return food.subs?.length ? food.subs.every(f => isFoodSoldOut(f)) : foodDetailsSoldOut(food);
}